import Vue from "vue";
import apis from "./api";
Vue.prototype.$apipcs = apis;
import messageBox from './message.js'
import solutionBox from './solutionStatus.js'
if(!sessionStorage.getItem("nomessage")){
    setTimeout(()=>{messageBox()},500)
}
let solutionStatus = true;
solutionStatus = JSON.parse(localStorage.getItem('setTempConfigs')) ? JSON.parse(localStorage.getItem('setTempConfigs')).solutionStatus : true;
console.log(solutionStatus,'solutionStatus')
if (solutionStatus === false) {
  console.log(solutionStatus === false,'solutionStatus === false')
  setTimeout(() =>{solutionBox()},500)
}
const addDetailRouter =(rootrRouter)=>{
    let routerList = [
      {
        path: '/newcms/list',
        name: 'newcms_list',
        meta: {
            weight: 0,
            noLogin: true,
        },
        component: () => import(/* webpackChunkName: 'error' */ './plugin/page/list.vue'),
    },
    {
        path: '/newcms/detail',
        name: 'newcms_detail',
        meta: {
            weight: 0,
            noLogin: true,
        },
        component: () => import(/* webpackChunkName: 'error' */ './plugin/page/detail.vue'),
    },
    {
        path: '/newcms/video',
        name: 'newcms_video',
        meta: {
            weight: 0,
            noLogin: true,
        },
        component: () => import(/* webpackChunkName: 'error' */ './plugin/page/video.vue')
      }
    ]
    rootrRouter.addRoutes(routerList)
  }
  export default addDetailRouter